import { createSlice } from '@reduxjs/toolkit';
import { patientAssignProviderMatch } from './api-wrappers';
import { updateMeta } from './meta';
import { MatchingState, RootState, Thunk } from './types';

const initialState: MatchingState = {
  matches: [],
  provider: null,
  zocdocProvider: null,
  appointmentTime: null,
  patientShouldNotBeMatchedReasons: [],
  zdProviderMatchFailureReasons: [],
  zdProviderTreatmentDealbreakerReasons: [],
};

export const matchingSlice = createSlice({
  name: 'matching',
  initialState,
  reducers: {
    setMatches: (state, action) => {
      state.matches = action.payload;
    },
    setProvider: (state, action) => {
      state.provider = action.payload;
    },
    setZocdocProvider: (state, action) => {
      state.zocdocProvider = action.payload;
    },
    setAppointmentTime: (state, action) => {
      state.appointmentTime = action.payload;
    },
    setPatientShouldNotBeMatchedReasons: (state, action) => {
      state.patientShouldNotBeMatchedReasons = action.payload;
    },
    setZdProviderMatchFailureReasons: (state, action) => {
      state.zdProviderMatchFailureReasons = action.payload;
    },
    setZdProviderTreatmentDealbreakerReasons: (state, action) => {
      state.zdProviderTreatmentDealbreakerReasons = action.payload;
    },
  },
});

export const {
  setMatches,
  setProvider,
  setZocdocProvider,
  setAppointmentTime,
  setPatientShouldNotBeMatchedReasons,
  setZdProviderMatchFailureReasons,
  setZdProviderTreatmentDealbreakerReasons,
} = matchingSlice.actions;

export const selectMatching = (state: RootState) => state.matching;

export const updateMatch =
  (input: Partial<MatchingState>): Thunk =>
  async (dispatch, getState) => {
    const { provider, appointmentTime } = input;
    const { session } = getState();
    const { errors } = await patientAssignProviderMatch(
      session.sessionPatientId,
      provider?.id
    );
    if (errors) return errors;

    dispatch(setProvider(provider));
    dispatch(setAppointmentTime(appointmentTime));
  };

export const updateNoMatch = (): Thunk => async (dispatch, getState) => {
  const { sessionPatientId } = getState().session;
  const { errors } = await patientAssignProviderMatch(sessionPatientId);
  if (errors) return errors;

  dispatch(setProvider(null));
  dispatch(updateMeta());
};

export default matchingSlice.reducer;
